import type { TableColumns, SorterProperties } from './tableProperties';

import type { OrderSearchParams } from '@/ui/Table/useTableRouter/seachOrder/functions';

export const getOrderBy = (
  orderBy?: OrderSearchParams['orderBy'],
): SorterProperties | undefined => {
  if (!orderBy) {
    return undefined;
  }
  return {
    columnKey: orderBy[0].column,
    order: orderBy[0].order === 'ASC' ? 'ascend' : 'descend',
  };
};

/**
 * For some unknown its only reactive if it's used in array.push(getColumn(...))
 */
export const getColumn = (
  column: TableColumns[0],
  sorted?: SorterProperties,
): TableColumns[0] => ({
  title: column.title,
  dataIndex: column.key,
  key: column.key,
  slots: column.slots,
  sorter: column.sorter,
  sortOrder: sorted && sorted.columnKey === column.key
    ? sorted.order
    : null,
});
